// store/events/actions.js
export const SET_ALL_EVENTS = 'SET_ALL_EVENTS';

export const setAllEvents = (data) => ({
  type: SET_ALL_EVENTS,
  payload: data,
});
